import { useMutation } from "react-query";
import axiosInstance from "./axiosInstance";

const loginToAdmin = async (clientId) => {
  if (!clientId) {
    throw new Error("Client ID is required");
  }

  const response = await axiosInstance.post(
    `/super-admin/client-management/client/${clientId}/impersonate`,
  );

  console.log(response, "ise re");

  return {
    ...response.data,
  };
};

export const useLoginToAdmin = () => {
  return useMutation(loginToAdmin, {
    onSuccess: (data) => {
      const protocol =
        process.env.NODE_ENV === "development" ? "http" : "https";
      if (data.payload) {
        window.open(
          `${protocol}://${data.payload.tenant_id}.${process.env.REACT_APP_CLIENT_WEBSITE_LINK}?administrator_token=${data.payload.token}`,
          "_blank",
        );
      }
    },
  });
};
